import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FETCH_OFFERS, SET_TAB } from 'dealer-reducers'
import { RootReducer } from '../../redux/rootReducer'
import Layout from '../layout/Layout'
import { useTranslation } from 'react-i18next'
import ArchiveSvg from '../other/svg/ArchiveSvg'
import FlatList from '../molecules/FlatList'
import { ListOffer } from 'dealer-types'
import ArchivedItemWrapper from '../molecules/ArchivedItemWrapper'
import OfferModal from './OfferModal'
import PaginatedOffers from './PaginatedOffers'
import OfferFilters from '../molecules/OfferFilters'

const Archived = (): JSX.Element => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const containerRef = useRef<HTMLDivElement>(null)
  const { offers } = useSelector((state: RootReducer) => state.offersListReducer.archive_accepted)
  const paginationType = useSelector((state: RootReducer) => state.layoutReducer.paginationType)
  const tab = useSelector((state: RootReducer) => state.offersListReducer.tab)

  useEffect(() => {
    dispatch(SET_TAB({ tab: 'archive_accepted' }))
    dispatch(FETCH_OFFERS({ tab: 'archive_accepted' }))
  }, [dispatch])

  return (
    <div>
      <Layout
        withoutToolbar={false}
        iconComponent={<ArchiveSvg className="w-8 h-8 text-white" />}
        withFiler={true}
        name={t('archive')}>
        <div className="h-full">
          <OfferFilters containerRef={containerRef} />
          <div className="h-[calc(100vh-200px)]">
            {paginationType === 'infinite' && (
              <FlatList
                data={offers}
                component={(itemProps: ListOffer) => <ArchivedItemWrapper {...itemProps} />}
                // eslint-disable-next-line require-await
                fetchMore={async () => {
                  dispatch(FETCH_OFFERS({ tab: 'archive_accepted' }))
                  // eslint-disable-next-line @typescript-eslint/return-await
                  return Promise.resolve()
                }}
                itemMinWidth={'100%'}
              />
            )}
            {paginationType === 'paginated' && tab === 'archive_accepted' && (
              <PaginatedOffers component={ArchivedItemWrapper} />
            )}
          </div>
        </div>
      </Layout>
      <OfferModal />
    </div>
  )
}

export default Archived
